import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
import moment from "moment";

export const dockingRequestReportListState = atom({
    key: 'dockingRequestReportListState',
    default: [],
})

export const dockingRequestReportZoneState = atom({
    key: 'dockingRequestReportZoneState',
    default: {
        data: [],
        ovf: false,
    }
})

export const dockingRequestReportCustomerState = atom({
    key: 'dockingRequestReportCustomerState',
    default: {
        data: [],
        ovf: false,
    }
})

export const dockingRequestReportVesselState = atom({
    key: 'dockingRequestReportVesselState',
    default: {
        data: [],
        ovf: false,
    }
})

export const dockingRequestReportFromDateState = atom({
    key: 'dockingRequestReportFromDateState',
    default: moment().subtract(1, 'month').format('YYYY-MM-DD'),
})

export const dockingRequestReportToDateState = atom({
    key: 'dockingRequestReportToDateState',
    default: moment().format('YYYY-MM-DD'),
})

export const dockingRequestReportZoneValueState = atom({
    key: 'dockingRequestReportZoneValueState',
    default: { label: "All", value: 0 },
})

export const dockingRequestReportCustomerValueState = atom({
    key: 'dockingRequestReportCustomerValueState',
    default: { label: "All", value: 0 },
})

export const dockingRequestReportVesselValueState = atom({
    key: 'dockingRequestReportVesselValueState',
    default: { label: "All", value: 0 },
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const dockingRequestReportFilterState = selector({
    key: 'dockingRequestReportFilterState',
    get: ({ get }) => ([
        {
            label: 'From Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(dockingRequestReportFromDateState),
        },
        {
            label: 'To Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(dockingRequestReportToDateState),
        },
        {
            label: 'Zone',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(dockingRequestReportZoneValueState),
            list: get(dockingRequestReportZoneState),
        },
        {
            label: 'Customer',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(dockingRequestReportCustomerValueState),
            list: get(dockingRequestReportCustomerState),
        },
        {
            label: 'Vessel',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(dockingRequestReportVesselValueState),
            list: get(dockingRequestReportVesselState),
        },
    ]),
    set: ({ set }, e) => {
        if(e.filterLabel === 'From Date'){
            set(dockingRequestReportFromDateState, e.value)
        }
        if(e.filterLabel === 'To Date'){
            set(dockingRequestReportToDateState, e.value)
        }
        if(e.filterLabel === 'Zone'){
            set(dockingRequestReportZoneValueState, e.value)
        }
        if(e.filterLabel === 'Customer'){
            set(dockingRequestReportCustomerValueState, e.value)
        }
        if(e.filterLabel === 'Vessel'){
            set(dockingRequestReportVesselValueState, e.value)
        }
    }
})

export const formModes = {
    view: [ { name: 'Default View' } ],
}

export const dockingRequestReportDataStructureState = selector({
    key: 'dockingRequestReportDataStructureState',
    get: ({ get }) => (
        [
            { 
                label: 'Customer',
                field: 'customer_name',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Vessel',
                field: 'vessel_name',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Zone',
                field: 'zone_name',
                type: 'text',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Type',
                field: 'type',
                type: 'text',
                order: { table: 5, form: 5 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Request Date',
                field: 'request_date',
                type: 'date',
                order: { table: 6, form: 6 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Start Time',
                field: 'start_time',
                type: 'time',
                order: { table: 7, form: 7 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'End Time',
                field: 'end_time',
                type: 'time',
                order: { table: 8, form: 8 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Status',
                field: 'status',
                type: 'text',
                order: { table: 9, form: 9 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
}) 